import { BdGraphNode, BdGraph, BdGraphStateMap, DoFunc } from './graph.model';

import { GraphUtils } from './graph-utils';

export function calculateLeafStateMap<TNode extends BdGraphNode>(
  graph: BdGraph<TNode>,
  state: BdGraphStateMap,
  properties: string[]
): BdGraphStateMap {

  const leafStateMap: BdGraphStateMap = {};

  const inheritedState = {};

  // handle inheritance of boolean properties 

  const inheritState: DoFunc = (id: string) => {
    if (GraphUtils.isRoot(graph, id)) {
      // reset inherited state for each graph root
      inheritedState[id] = { ...GraphUtils.getState(graph, id, properties), ...state[id] || {} };
    } else {
      // merge state onto inherited parent state
      const parentId = graph.predecessors[id];
      inheritedState[id] = { ...inheritedState[parentId], ...state[id] || {} };
    }

    // record state in leaf state map
    if (GraphUtils.isLeaf(graph, id)) {
      leafStateMap[id] = inheritedState[id];
    }
  };

  // propagate down the tree
  GraphUtils.depthFirst(graph, inheritState);


  // return state of only leaf nodes
  return leafStateMap;
}
